export default __webpack_public_path__ + "static/media/search-icon.3e75f036.svg";